import { constants } from "../actions/result";
const defaultState = {
  downloadInfo: {},
  speedTestResultInfo: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case constants.SAVE_DATA:
      return Object.assign({}, state, {
        ...action.payload,
      });
    case constants.SAVE_DONWLOAD_INFO:
      return Object.assign({}, state, {
        downloadInfo: action.payload,
      });
    default:
      return state;
  }
};
